import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Icon, Col, Modal, notification, Row, Tooltip } from 'antd'
import moment from 'moment'
import {
  addFeedbackFxn,
  addReassessmentFxn,
  getAssessmentActivityFxn,
  getCallbackFxn,
  getSingleAssessmentFxn
} from '../action'
import { useDispatch } from 'react-redux'
import InputBox from '../../../components/_utils/InputBox'

const ReAssessmentDrawer = ({
                              reAssessmentVisible,
                              setReAssessmentVisible,
                              concernText,
                              setConcernText,
                              data,
                              onClose
                            }) => {
  let dispatch = useDispatch()
  const addReassessment = async () => {
    if (!concernText.trim()) {
      return notification.warning({ message: 'Concern is required' })
    }
    let obj = {
      id: data._id,
      concern: concernText.trim()
    }
    let response = await dispatch(addReassessmentFxn(obj))
    if (response.success) {
      onClose()
    }
  }
  return (
    <Drawer
      visible={reAssessmentVisible}
      title='Re-Assessment Concern'
      placement='right'
      width={600}
      onClose={() => onClose()}
    >
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <InputBox title={'Please enter your concern'}>
              <textarea
                rows={6}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', borderColor: '#ccc' }}
                placeholder='Enter your concern here...'
                value={concernText}
                onChange={(e) => setConcernText(e.target.value)}
              />
            </InputBox>
          </div>
          <Button
            type='primary'
            className='ml10'
            onClick={() => {
              addReassessment().then(() => {
                setConcernText('')
              })
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </Drawer>
  )
}

const CloseAssessmentDrawer = ({ closeAssessmentVisible, setCloseAssessmentVisible, data, refreshData }) => {
  const [showReasonInput, setShowReasonInput] = useState(false)
  const [reasonText, setReasonText] = useState('')
  const dispatch = useDispatch()

  const addFeedback = async (type) => {
    let objs = {
      status: type,
      id: data._id
    }

    if (type === 'not satisfied' && !reasonText.trim()) {
      return notification.warning({
        message: 'Please enter reason.'
      })
    }

    if (reasonText.trim()) {
      objs.reason = reasonText.trim()
    }

    const response = await dispatch(addFeedbackFxn(objs))
    if (response.success) {
      setCloseAssessmentVisible(false)
      setShowReasonInput(false)
      setReasonText('')
      refreshData()
    }
  }

  return (
    <Modal
      visible={closeAssessmentVisible}
      title='Close Assessment'
      onCancel={() => {
        setCloseAssessmentVisible(false)
        setShowReasonInput(false)
        setReasonText('')
      }}
      footer={null}
      width='30%'>
      <div className='close-assessment-content'>
        <p className='companySuccessText' style={{ textAlign: 'center' }}>
          Are you satisfied with this assessment?
        </p>
        <div className={'d-flex mt20'}>
          <a className={`btn  ${!showReasonInput ? 'btn-success-dark' : 'btn-default'}  xl roundNew2 w-100`}
             onClick={() => addFeedback('satisfied')}>
            Yes
          </a>
          <a className={`btn  ${showReasonInput ? 'btn-success-dark' : 'btn-default'} xl roundNew2 w-100`}
             onClick={() => setShowReasonInput(true)}>
            No
          </a>
        </div>
        {showReasonInput ? (
          <>
            <InputBox title={'Enter Reason'}>
                    <textarea
                      className={'form-control'}
                      rows={3}
                      placeholder='Please enter your reason...'
                      value={reasonText}
                      onChange={(e) => setReasonText(e.target.value)}
                    />
            </InputBox>
            <a
              className={'btn btn-success  xl roundNew w-100'}
              type='primary'
              onClick={() => addFeedback('not satisfied')}>
              Submit Feedback
            </a>
          </>
        ) : null}

      </div>
    </Modal>
  )
}

const CallbackAssessmentDrawer = ({ callbackAssessmentVisible, setCallbackAssessmentVisible, data, contactNumber }) => {
  const [showReasonInput, setShowReasonInput] = useState(false)
  const [reasonText, setReasonText] = useState('')
  const dispatch = useDispatch()

  return (
    <Modal
      visible={callbackAssessmentVisible}
      title='Request a callback'
      onCancel={() => {
        setCallbackAssessmentVisible(false)
        setShowReasonInput(false)
        setReasonText('')
      }}
      footer={null}
      width='30%'
    >
      <div className='close-assessment-content'>
        <h2>Callback Request</h2>
        <p className='companySuccessText' style={{ textAlign: 'center' }}>
          Your Contact Number Is <br />
          {contactNumber}
        </p>

        <div style={{ textAlign: 'center' }}>
          <Row gutter={16} style={{ marginTop: 24, display: 'inline-block' }}>
            <Col span={12}>
              <Button
                className='assessButtons'
                type='primary'
                block
                /*onClick={() => addFeedback('satisfied')}*/
              >
                Edit Number
              </Button>
            </Col>
            <Col span={12}>
              <Button
                className='assessButtonsDefault'
                type='default'
                block
                onClick={() => setShowReasonInput(true)}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  )
}

const AssessmentAgentProfile = (props) => {
  let { visible, onClose, assessmentData } = props
  let dispatch = useDispatch()
  let [requestCallBack, setRequestCallBack] = useState([])
  let [assessmentActivity, setAssessmentActivity] = useState([])
  let [reAssessmentVisible, setReAssessmentVisible] = useState(false)
  let [concernText, setConcernText] = useState('')
  let [closeAssessmentVisible, setCloseAssessmentVisible] = useState(false)
  let [singleAssessment, setSingleAssessment] = useState({})
  let [callbackAssessmentVisible, setCallbackAssessmentVisible] = useState(false)

  useEffect(() => {
    if (assessmentData._id) {
      assEvents.refreshData()
    }
  }, [assessmentData._id])

  const assEvents = {
    openDocument: (path) => {
      window.open(path, '_blank')
    },
    refreshData: () => {
      getAssessmentActivityEvent()
      getSingleAssessmentEvent()
    }
  }

  const getCallbackStatusFxn = async () => {
    try {
      let data = await dispatch(getCallbackFxn(assessmentData._id))
      setRequestCallBack(data.requestCallBack)
      setAssessmentActivity(data.assessmentActivity)
    } catch (err) {
    }
  }
  const getAssessmentActivityEvent = async () => {
    try {
      let { data } = await dispatch(getAssessmentActivityFxn({ assessmentId: assessmentData._id }))
      setAssessmentActivity(data)
    } catch (err) {
    }
  }
  const getSingleAssessmentEvent = async () => {
    try {
      let { data } = await dispatch(getSingleAssessmentFxn({ assessmentId: assessmentData._id }))
      setSingleAssessment(data)
    } catch (err) {
    }
  }
  useEffect(() => {
    if (assessmentData && assessmentData._id) {
      getCallbackStatusFxn()
    }
  }, [assessmentData])

  const closeFxn = () => {
    onClose(assessmentData)
  }

  return (
    <Drawer
      visible={visible}
      width={'50%'}
      placement='right'
      closable={false}
      onClose={closeFxn}
      bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      {/* Scrollable Content */}
      <div style={{ flex: 1, overflowY: 'auto' }} className='p-4'>
        <div className='p-4 mb-4 assessment_profile_card'>
          <a className={'cross_btn'} onClick={closeFxn}>
            <Tooltip title={'Delete'}>
              <Icon type={'close'} />
            </Tooltip>
          </a>
          <div className={'jcsb assessment-info-box'}>
            <div>
              <h3 className={'person-name'}>
                {singleAssessment && singleAssessment.contactPersonName}
              </h3>
              DOB: {singleAssessment && moment(singleAssessment.dateOfBirth).format('DD-MM-YYYY')} •
              Passport: {singleAssessment && singleAssessment.passportNumber}
            </div>
          </div>

          <div className={'document_box'}>
            {singleAssessment && singleAssessment.documents && singleAssessment.documents.map((item, index) => (
              <div key={index} className='doc-preview-card pCursor' onClick={() => assEvents.openDocument(item.path)}>
                <img src='../images/google-docs.png' alt='DOC' className='doc-card-icon' />
                <div className='doc-card-name'>
                  {item.fileName &&
                  `${item.fileName.slice(0, 6)}...${item.fileName.slice(item.fileName.lastIndexOf('.'))}`
                  }
                  {!item.fileName && 'Untitled'}
                </div>
              </div>
            ))}
          </div>
        </div>

        {assessmentActivity && assessmentActivity.length > 0 && assessmentActivity.map((item, index) => (
          <div key={index} className='d-flex flex-column'>
            {item.document && item.document.path && (
              <>
                <div className='d-flex justify-content-end'>
                  <a onClick={() => assEvents.openDocument(item.document.path)}
                     className='doc-bubble d-flex align-items-center pCursor'>
                    <div className='doc-image-section'>
                      <img src='../images/google-docs.png' alt='doc' className='doc-icon' />
                    </div>
                    <div className='doc-text'>
                      <strong className='doc-filename'>
                        {(item.document.fileName && item.document.fileName) || 'Untitled.pdf'}
                      </strong>
                    </div>
                  </a>
                </div>

                <div className='d-flex justify-content-end mb-1' style={{ fontSize: '12px', color: '#888' }}>
                  {item.assignBy && item.assignBy.companyName && (
                    <div className='font-weight-bold'>From {item.assignBy.companyName}</div>
                  )}
                </div>
              </>
            )}

            {item.concern && (
              <div className='d-flex justify-content-start mb-1'>
                <div className='p-3 rounded assessment_activity_card'>
                  <div style={{ fontSize: '14px', color: '#000' }}>
                    {item.concern}
                  </div>
                </div>
              </div>
            )}

            {item.type === 'closed' && (
              <div className='d-flex justify-content-start mb-1'>
                <div className='p-3 rounded assessment_activity_card'>
                  {item.message}
                  <div
                    className={`satisfied_text ${item.satisfied === 'satisfied' && 'successText'} ${item.satisfied === 'not satisfied' && 'dangerText'}`}>
                    {item.satisfied}
                    {item.satisfied === 'satisfied' && ' 🙂'}
                    {item.satisfied === 'not satisfied' && ' 😔'}
                  </div>
                  {item.reason && <div>Reason : {item.reason}</div>}
                </div>
              </div>
            )}

            {item.type === 'callbackRequested' && (
              <div className='d-flex justify-content-start mb-1'>
                <div className='p-3 rounded assessment_activity_card'>
                  <div style={{ fontSize: '14px', color: '#000' }}>
                    {item.message}<br />
                    Status: {(item.callbackId && item.callbackId.status === 'Pending') && 'Open'}
                    {(item.callbackId && item.callbackId.status !== 'Pending') && 'Close'}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>


      {/* Fixed Bottom Buttons */}
      <div className={'ass-footer'}>
        {singleAssessment && singleAssessment.status == 'assessed' && singleAssessment.assessmentCount < 3 &&
        <a className='btn btn-success-dark xl roundNew2' onClick={() => setReAssessmentVisible(true)}>
          Re-Assessment
        </a>
        }
        {singleAssessment && singleAssessment.status == 'assessed' &&
        <>
          <a className='btn btn-success-dark xl roundNew2' onClick={() => setCloseAssessmentVisible(true)}>
            Close Assessment
          </a>
          {/*<a className='btn btn-success-dark xl roundNew2' onClick={() => setCallbackAssessmentVisible(true)}>
            Request a callback
          </a>*/}
        </>
        }

        {singleAssessment && singleAssessment.status == 'viewed' && (
          <Alert
            message='Team is processing your documents.'
            description='We will send you the assessment soon.'
            type='info'
            showIcon
            style={{ width: '100%' }}
          />
        )}
        {singleAssessment && singleAssessment.status == 'pending' && (
          <Alert
            message={`Team is processing your ${singleAssessment.assessmentCount > 1 ? 'concern' : 'request'}.`}
            description={`We will send you ${
              singleAssessment.assessmentCount > 1 ? 'reassessment' : 'assessment'
            } soon.`}
            type='info'
            showIcon
            style={{ width: '100%' }}
          />
        )}


      </div>

      {reAssessmentVisible &&
      <ReAssessmentDrawer
        reAssessmentVisible={reAssessmentVisible}
        concernText={concernText}
        setConcernText={setConcernText}
        data={singleAssessment}
        onClose={() => {
          setReAssessmentVisible(false)
          assEvents.refreshData()
        }}
      />}

      <CloseAssessmentDrawer
        closeAssessmentVisible={closeAssessmentVisible}
        setCloseAssessmentVisible={setCloseAssessmentVisible}
        data={singleAssessment}
        refreshData={() => {
          assEvents.refreshData()
        }}
      />

      <CallbackAssessmentDrawer
        callbackAssessmentVisible={callbackAssessmentVisible}
        setCallbackAssessmentVisible={setCallbackAssessmentVisible}
        data={singleAssessment}
      />

    </Drawer>
  )
}
export default AssessmentAgentProfile
